module.exports = __webpack_public_path__ + "img/66.cf3445d9.png";